import { EBeforeWinAnimationEvents } from '@Core/BeforeWinAnimation/BeforeWinAnimationEvents';
import { EWildWheelFeatureEvents } from '@Core/WildWheelFeature/States/WildWheelFeatureEvents';
import { EWildWheelFeatureStates } from '@Core/WildWheelFeature/States/WildWheelFeatureStates';
import { EWinPresentationStates } from '@Core/Win/States/WinPresentationStates';
import { EGameStates } from '@Managers/StateManager/GameStates';
import { EBonusBuyEvents } from './BonusBuyEvents';
import { EButtonEvents } from './ButtonEvents';
import { EActionName } from './EActionName';
import { ESymbolEvents } from './SymbolEvents';

export enum EGameEvents {
    // PRELOADER
    ASSETS_PRELOAD_FINISHED = 'ASSETS_PRELOAD_FINISHED',
    ASSET_LOADER_INFORMATION = 'ASSET_LOADER_INFORMATION',
    ASSETS_STATE_UPDATE = 'ASSETS_STATE_UPDATE',
    ASSETS_LOAD_FINISHED = 'ASSETS_LOAD_FINISHED',
    PRELOADER_LOGO_ANIMATION_COMPLETED = 'PRELOADER_LOGO_ANIMATION_COMPLETED',
    PRELOADER_INTRO_MOVIE_PLAY = 'PRELOADER_INTRO_MOVIE_PLAY',
    PRELOADER_INTRO_MOVIE_SKIP = 'PRELOADER_INTRO_MOVIE_SKIP',
    PRELOADER_INFO_READY = 'PRELOADER_INFO_READY',
    PRELOADER_INFO_CONTINUE = 'PRELOADER_INTRO_MOVIE_SKIP',

    // RESPONSES
    GAME_INSTANCE_READY = 'GAME_INSTANCE_READY',
    SEND_ACTION_REQUEST = 'SEND_ACTION_REQUEST',
    ACTION_RESPONSE_RECEIVED = 'ACTION_RESPONSE_RECEIVED',
    ACTION_RESPONSE_PROCESSED = 'ACTION_RESPONSE_PROCESSED',
    REFRESH_BALANCE_RECEIVED = 'REFRESH_BALANCE_RECEIVED',
    REFRESH_BALANCE_PROCESSED = 'REFRESH_BALANCE_PROCESSED',

    // BUTTONS
    SKIP = 'SKIP',
    CONTINUE = 'CONTINUE',
    TAKE = 'TAKE',
    MUTE = 'MUTE',
    UNMUTE = 'UNMUTE',
    FULLSCREEN = 'FULLSCREEN',
    EXIT_FULLSCREEN = 'EXIT_FULLSCREEN',
    SKIP_SHORTS = 'SKIP_SHORTS',
    JACKPOT_CASINO_NOTIFICATION = 'JACKPOT_CASINO_NOTIFICATION',

    // POP CLIENT
    INITIATE_PAUSE = 'INITIATE_PAUSE',
    PAUSE = 'PAUSE',
    INITIATE_UNPAUSE = 'INITIATE_UNPAUSE',
    UNPAUSE = 'UNPAUSE',
    PAUSE_STATUS = 'PAUSE_STATUS',
    GAME_ROUND_START = 'GAME_ROUND_START',
    GAME_ROUND_END = 'GAME_ROUND_END',
    AUTOPLAY_MODE_START = 'AUTOPLAY_START',
    AUTOPLAY_MODE_END = 'AUTOPLAY_MODE_END',
    BET_UPDATE = 'BET_UPDATE',

    ERROR = 'ERROR',
    TRANSACTION_CYCLE_START = 'TRANSACTION_CYCLE_START',
    TRANSACTION_CYCLE_END = 'TRANSACTION_CYCLE_END',

    // UI
    ON_CLICK = 'ON_CLICK',
    UI_TOGGLE = 'UI_TOGGLE',
    OPEN_PAGE = 'OPEN_PAGE',
    UI_STATE = 'UI_STATUS',
    CLOSE_GAME_FRAME_COMMAND = 'CLOSE_GAME_FRAME_COMMAND',

    CYCLE_WINLINE_$ = 'CYCLE_WINLINE_$',
    CYCLE_WINLINE = 'CYCLE_WINLINE',
    CYCLE_WAYS = 'CYCLE_WAYS',
    CYCLE_SCATTERS = 'CYCLE_SCATTERS',

    // ODOMETER WIN TIERS
    WIN_IN = 'WIN_IN',
    WIN = 'WIN',
    WIN_OUT = 'WIN_OUT',
    BIG_WIN_IN = 'BIG_WIN_IN',
    BIG_WIN = 'BIG_WIN',
    BIG_WIN_OUT = 'BIG_WIN_OUT',
    HUGE_WIN_IN = 'HUGE_WIN_IN',
    HUGE_WIN = 'HUGE_WIN',
    HUGE_WIN_OUT = 'HUGE_WIN_OUT',
    MEGA_WIN_IN = 'MEGA_WIN_IN',
    MEGA_WIN = 'MEGA_WIN',
    MEGA_WIN_OUT = 'MEGA_WIN_OUT',
    JACKPOT_WIN_IN = 'JACKPOT_WIN_IN',
    JACKPOT_WIN = 'JACKPOT_WIN',
    JACKPOT_WIN_OUT = 'JACKPOT_WIN_OUT',
    MINI_JACKPOT_IN = 'MINI_JACKPOT_IN',
    MINI_JACKPOT = 'MINI_JACKPOT',
    MINI_JACKPOT_OUT = 'MINI_JACKPOT_OUT',
    MINOR_JACKPOT_IN = 'MINOR_JACKPOT_IN',
    MINOR_JACKPOT = 'MINOR_JACKPOT',
    MINOR_JACKPOT_OUT = 'MINOR_JACKPOT_OUT',
    MAJOR_JACKPOT_IN = 'MAJOR_JACKPOT_IN',
    MAJOR_JACKPOT = 'MAJOR_JACKPOT',
    MAJOR_JACKPOT_OUT = 'MAJOR_JACKPOT_OUT',
    GRAND_JACKPOT_IN = 'GRAND_JACKPOT_IN',
    GRAND_JACKPOT = 'GRAND_JACKPOT',
    GRAND_JACKPOT_OUT = 'GRAND_JACKPOT_OUT',
    JACKPOT_WIN_1_IN = 'JACKPOT_WIN_1_IN',
    JACKPOT_WIN_1 = 'JACKPOT_WIN_1',
    JACKPOT_WIN_1_OUT = 'JACKPOT_WIN_1_OUT',
    JACKPOT_WIN_2_IN = 'JACKPOT_WIN_2_IN',
    JACKPOT_WIN_2 = 'JACKPOT_WIN_2',
    JACKPOT_WIN_2_OUT = 'JACKPOT_WIN_2_OUT',
    JACKPOT_WIN_3_IN = 'JACKPOT_WIN_3_IN',
    JACKPOT_WIN_3 = 'JACKPOT_WIN_3',
    JACKPOT_WIN_3_OUT = 'JACKPOT_WIN_3_OUT',
    JACKPOT_WIN_4_IN = 'JACKPOT_WIN_4_IN',
    JACKPOT_WIN_4 = 'JACKPOT_WIN_4',
    JACKPOT_WIN_4_OUT = 'JACKPOT_WIN_4_OUT',
    JACKPOT_WIN_5_IN = 'JACKPOT_WIN_5_IN',
    JACKPOT_WIN_5 = 'JACKPOT_WIN_5',
    JACKPOT_WIN_5_OUT = 'JACKPOT_WIN_5_OUT',

    // WIN_MULTIPLIER_EVENTS
    WIN_X_$ = 'WIN_X_$',

    // REELS ANIMATION EVENTS
    REEL_ANIMATION_START = 'REEL_ANIMATION_START',
    REEL_SPIN_START_$ = 'REEL_SPIN_START_$',
    PRE_REEL_SPIN_END_$ = 'PRE_REEL_SPIN_END_$',
    REEL_SPIN_END_$ = 'REEL_SPIN_END_$',
    REEL_ANIMATION_END = 'REEL_ANIMATION_END',
    QUICK_STOP = 'QUICK_STOP',

    // REEL TENSION EVENTS
    TENSION_START_$ = 'TENSION_START_$',
    TENSION_INTRO_$ = 'TENSION_INTRO_$',
    TENSION_INTRO = 'TENSION_INTRO',
    TENSION_LOOP_$ = 'TENSION_LOOP_$',
    TENSION_LOOP = 'TENSION_LOOP',
    AFTER_TENSION_START_$ = 'AFTER_TENSION_START_$',
    TENSION_LOSE_$ = 'TENSION_LOSE_$',
    TENSION_WIN_$ = 'TENSION_WIN_$',
    INTERRUPT_TENSION = 'INTERRUPT_TENSION',

    PLAY_SOUND_BY_KEY = 'PLAY_SOUND_BY_KEY',

    DEVICE_DIMENSIONS_CHANGED = 'DEVICE_DIMENSIONS_CHANGED',
    RESIZE_REELS = 'RESIZE_REELS',
    RESIZED_REELS = 'RESIZED_REELS',
    RESIZE_SYMBOLS = 'RESIZE_SYMBOLS',
    STOP_SYMBOL_ANIMATIONS = 'STOP_SYMBOL_ANIMATIONS',
    UPDATE_VISIBLE_SYMBOLS = 'UPDATE_VISIBLE_SYMBOLS',

    PAGE_$ = 'PAGE_$',

    INFO_DISPLAY_$ = 'INFO_DISPLAY_$',

    GAME_LOGOUT = 'GAME_LOGOUT',

    SYMBOL_EXPANDING = 'SYMBOL_EXPANDING',
    SYMBOL_EXPANDING_WIN = 'SYMBOL_EXPANDING_WIN',
    SYMBOL_EXPANDING_$ = 'SYMBOL_EXPANDING_$',
    WIN_BEFORE_EXPANDING_SYMBOLS_SOUND = 'WIN_BEFORE_EXPANDING_SYMBOLS_SOUND',

    // SPECIAL GAMES
    SPECIAL_GAMES_INTRO = 'SPECIAL_GAMES_INTRO',
    SPECIAL_GAMES_OUTRO = 'SPECIAL_GAMES_OUTRO',
    SPECIAL_GAMES_START_INFO_SHOW = 'SPECIAL_GAMES_START_INFO_SHOW',
    SPECIAL_GAMES_START_INFO_HIDE = 'SPECIAL_GAMES_START_INFO_HIDE',
    SPECIAL_GAMES_RETRIGGER_SHOW = 'SPECIAL_GAMES_RETRIGGER_SHOW',
    SPECIAL_GAMES_RETRIGGER_HIDE = 'SPECIAL_GAMES_RETRIGGER_HIDE',
    SPECIAL_GAMES_SUMMARY_SHOW = 'SPECIAL_GAMES_SUMMARY_SHOW',
    SPECIAL_GAMES_SUMMARY_HIDE = 'SPECIAL_GAMES_SUMMARY_HIDE',
    SPECIAL_GAMES_TOTAL_COUNTER_CHANGE = 'SPECIAL_GAMES_TOTAL_COUNTER_CHANGE',
    SPECIAL_GAMES_PLAYED_COUNTER_CHANGE = 'SPECIAL_GAMES_PLAYED_COUNTER_CHANGE',
    SPECIAL_GAMES_MODE_ENTRY = 'SPECIAL_GAMES_MODE_ENTRY',
    SPECIAL_GAMES_MODE_EXIT = 'SPECIAL_GAMES_MODE_EXIT',
    SPECIAL_GAMES_MODE_SWITCH = 'SPECIAL_GAMES_MODE_SWITCH',
    SPECIAL_GAMES_RESTORE = 'SPECIAL_GAMES_RESTORE',

    SPECIAL_GAMES_SYMBOL_DRAW = 'SPECIAL_GAMES_SYMBOL_DRAW',
    SPECIAL_GAMES_SYMBOL_SELECT = 'SPECIAL_GAMES_SYMBOL_SELECT',
    SPECIAL_GAMES_INTRO_END = 'SPECIAL_GAMES_INTRO_END',

    // LOCK AND ROLL
    LR_POS_$ = 'LR_POS_$',
    LOCK_AND_ROLL_COIN_COUNT_CHANGE = 'LOCK_AND_ROLL_COIN_COUNT_CHANGE',
    SPECIAL_GAMES_COLLECTED = 'SPECIAL_GAMES_COLLECTED',

    // HISTORY EVENTS
    INGAME_HISTORY_REPLAY_SPIN = 'INGAME_HISTORY_REPLAY_SPIN',
    INGAME_HISTORY_INDEX_CHANGE = 'INGAME_HISTORY_INDEX_CHANGE',
    INGAME_HISTORY_CLOSE = 'INGAME_HISTORY_CLOSE',
    INGAME_HISTORY_OPEN = 'INGAME_HISTORY_OPEN',

    WIN_MULTIPLIER_PRESENTATION_START = 'WIN_MULTIPLIER_PRESENTATION_START',
    WIN_MULTIPLIER_PRESENTATION_END = 'WIN_MULTIPLIER_PRESENTATION_END',
    WIN_MULTIPLIER_PRESENTATION_$ = 'WIN_MULTIPLIER_PRESENTATION_$',

    // COLLECTORS
    COLLECTOR_$_LEVEL_$_IN = 'COLLECTOR_$_LEVEL_$_IN',
    COLLECTOR_$_LEVEL_$ = 'COLLECTOR_$_LEVEL_$',
    COLLECTOR_$_LEVEL_$_OUT = 'COLLECTOR_$_LEVEL_$_OUT',
    COLLECTOR_$_LEVEL_$_WIN = 'COLLECTOR_$_LEVEL_$_WIN',

    // UNIQUE EVENT WHEN REEL COUNT CHANGES
    CHANGE_REEL_COUNT = 'CHANGE_REEL_COUNT'
}
export const ALL_EVENTS_LIST = {
    ...EGameEvents,
    ...EWinPresentationStates,
    ...EWildWheelFeatureStates,
    ...EWildWheelFeatureEvents,
    ...EBeforeWinAnimationEvents,
    ...EGameStates,
    ...EButtonEvents,
    ...ESymbolEvents,
    ...EBonusBuyEvents
};

export const EVENTS_NUMBER_PLACEHOLDER = '$';

export type TUserAction = {
    actionName: EActionName;
    bet?: number;
    params?: {
        gambleAmount?: number;
        option?: number; // note - gamble option
    };
    fix?: string;
};

export const isWildcardEvent = (event: string): boolean => {
    return event?.includes(EVENTS_NUMBER_PLACEHOLDER);
};
